import Gallery from '../blocks/gallery';

const templateServices = {
  init() {
    new Gallery('.gallery');
  }
}
export default templateServices;
